module.exports = __webpack_public_path__ + "img/img-f2ed5f.png";